const API_PREFIX = "/viber";

export const getViberQuotaEndpoint = () => `${API_PREFIX}/quota`;
export const getViberQuotaHistoryEndpoint = (year: number, month: number) => `${API_PREFIX}/quota/history?year=${year}&month=${month}`;
export const viberTopupEndpoint = () => `${API_PREFIX}/quota/topup`;
export const updateViberSettingsEndpoint = () => `${API_PREFIX}/quota/settings`;
export const getViberMessagesEndpoint = (
  skip?: number,
  limit?: number,
  messageType?: string,
  status?: string,
  dateFrom?: string,
  dateTo?: string,
  phoneNumber?: string
) => {
  const params = new URLSearchParams();
  if (skip !== undefined) params.append('skip', skip.toString());
  if (limit !== undefined) params.append('limit', limit.toString());
  if (messageType) params.append('messageType', messageType);
  if (status) params.append('status', status);
  if (dateFrom) params.append('dateFrom', dateFrom);
  if (dateTo) params.append('dateTo', dateTo);
  if (phoneNumber) params.append('phoneNumber', phoneNumber);
  return `${API_PREFIX}/messages?${params.toString()}`;
};

export const getViberMessagesByPhoneEndpoint = (phoneNumber: string) =>
  `${API_PREFIX}/messages/phone/${encodeURIComponent(phoneNumber)}`;

export const sendViberMarketingEndpoint = () => `${API_PREFIX}/marketing/send`;
export const sendViberMarketingWithImageEndpoint = () => `${API_PREFIX}/marketing/send-with-image`;

export const getViberMessageHistoryEndpoint = (
  page?: number,
  limit?: number,
  phoneNumber?: string,
  messageType?: string,
  status?: string,
  dateFrom?: string,
  dateTo?: string,
  reservationId?: string,
  clientId?: string
) => {
  const params = new URLSearchParams();
  if (page !== undefined) params.append('page', page.toString());
  if (limit !== undefined) params.append('limit', limit.toString());
  if (phoneNumber) params.append('phoneNumber', phoneNumber);
  if (messageType) params.append('messageType', messageType);
  if (status) params.append('status', status);
  if (dateFrom) params.append('dateFrom', dateFrom);
  if (dateTo) params.append('dateTo', dateTo);
  if (reservationId) params.append('reservationId', reservationId);
  if (clientId) params.append('clientId', clientId);
  return `${API_PREFIX}/messages?${params.toString()}`;
};

export const getViberCountersEndpoint = () => `${API_PREFIX}/counters`;
export const updateViberServiceLimitEndpoint = () => `${API_PREFIX}/service-limit`;
